<template>
    <b-row>
        <b-col lg="12">
            <!-- .name -->
            <validation-observer ref="registerForm" #default="{ invalid }">
                <b-form>
                    <b-row>
                                <!-- .user -->
<b-col lg="6">
    <b-form-group id="input-group-1" :label="$t('loans.user')" label-for="input-1">
        <validation-provider #default="{ errors }" name="user" vid="user" rules="required">
            <b-form-select v-model="user"
                           :options="users"
                           text-field="name"
                           value-field="id"
                           :state="errors.length > 0 ? false : null"
                           :placeholder="$t('loans.user')" />
            <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
    </b-form-group>
</b-col>        <!-- .name -->
<b-col lg="6">
    <b-form-group id="input-group-2" :label="$t('loans.name')" label-for="input-2">
        <validation-provider #default="{ errors }" name="name" vid="name" rules="required">

            <b-form-input id="input-2" v-model="newItem.name" type="text" :placeholder="$t('loans.name')" :state="errors.length > 0 ? false : null">
            </b-form-input>
            <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
    </b-form-group>
</b-col>        <!-- .amount -->
<b-col lg="6">
    <b-form-group id="input-group-3" :label="$t('loans.amount')" label-for="input-3">
        <validation-provider #default="{ errors }" name="amount" vid="amount" rules="required">

            <b-form-input id="input-3" v-model="newItem.amount" type="text" :placeholder="$t('loans.amount')" :state="errors.length > 0 ? false : null">
            </b-form-input>
            <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
    </b-form-group>
</b-col>        <!-- .number_of_installments -->
<b-col lg="6">
    <b-form-group id="input-group-4" :label="$t('loans.number_of_installments')" label-for="input-4">
        <validation-provider #default="{ errors }" name="number_of_installments" vid="number_of_installments" rules="required">

            <b-form-input id="input-4" v-model="newItem.number_of_installments" type="text" :placeholder="$t('loans.number_of_installments')" :state="errors.length > 0 ? false : null">
            </b-form-input>
            <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
    </b-form-group>
</b-col>        <!-- .remaining_installments -->
<b-col lg="6">
    <b-form-group id="input-group-5" :label="$t('loans.remaining_installments')" label-for="input-5">
        <validation-provider #default="{ errors }" name="remaining_installments" vid="remaining_installments" rules="required">

            <b-form-input id="input-5" v-model="newItem.remaining_installments" type="text" :placeholder="$t('loans.remaining_installments')" :state="errors.length > 0 ? false : null">
            </b-form-input>
            <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
    </b-form-group>
</b-col>        <!-- .description -->
<b-col lg="6">
    <b-form-group id="input-group-6" :label="$t('loans.description')" label-for="input-6">
        <validation-provider #default="{ errors }" name="description" vid="description" rules="required">
            <ckeditor :config="{ contentsLangDirection : 'rtl',versionCheck : false}"  id="textarea-2"
                      v-model="newItem.description"
                      :state="errors.length > 0 ? false : null"
                      :placeholder="$t('polls.description')"
                      rows="8" />
            <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
    </b-form-group>
</b-col>

                    </b-row>
                    <hr />
                    <b-row>
                        <b-col lg="6">
                            <b-button block
                                     
                                      :disabled="invalid"
                                      variant="primary"
                                      @click="submit()">
                                <i class="fa fa-plus" /> {{ $t("site.save") }}
                            </b-button>
                        </b-col>
                        <b-col lg="6">
                            <b-button block  @click="goToTable()"  variant="success">
                                <i class="fas fa-ban"></i> {{ $t("site.cancel") }}
                            </b-button>
                        </b-col>
                    </b-row>
                </b-form>
            </validation-observer>
        </b-col>
    </b-row>
</template>

<script>
    import Controller from '@/Controllers/LoansController';
    import config from '@/config/config';
    import { ValidationProvider, ValidationObserver } from "vee-validate";
    import { required } from "@validations";
     export default {
        name: "LoansForm",
        props: ['newItem'],
        components: {
            ValidationProvider,
            ValidationObserver,
            required,
        },
        data() {
            return {
                file: {},
                
                        user:[],


            };
        },
        methods: {
            async    goToTable() {
      this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
      this.$parent.$parent.firstTab();
    },
    async submit() {
                let ret = await new Controller().From(this.newItem, "FormData");
                if (ret) {
                    this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
                    this.$parent.$parent.firstTab();
                }
            },
        },

};
</script>

